import heroAvif from "@/assets/hero-beach.avif.asset.json";
import heroWebp from "@/assets/hero-beach.webp.asset.json";
import heroJpg from "@/assets/hero-beach.jpg.asset.json";
import { Button } from "@/components/ui/button";
import { MapPin, ShieldCheck, Zap, Home } from "lucide-react";
import InventoryStrip from "@/components/InventoryStrip";

const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-svh flex items-start justify-center overflow-visible pt-48 pb-10 md:pt-48 md:pb-12 lg:pt-48 lg:pb-14">
      <div className="absolute inset-0 overflow-hidden">
        <picture>
          <source type="image/avif" srcSet={heroAvif.url} />
          <source type="image/webp" srcSet={heroWebp.url} />
          <img
            src={heroJpg.url}
            alt="Panama City Beach coastline at sunset"
            width={1920}
            height={1080}
            fetchPriority="high"
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover animate-ken-burns will-change-transform"
          />
        </picture>
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
      </div>

      <div className="relative z-10 my-auto text-center max-w-5xl mx-auto px-6">
        <h1 className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl text-white font-display font-semibold tracking-tight leading-[1.05] mb-6 animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
          Premier Beach Houses
        </h1>
        <p className="text-lg md:text-xl text-white font-body font-light mb-8 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: "0.15s" }}>
          Enjoy pristine properties, dedicated local hospitality, and transparent pricing on every stay.
        </p>
        <div className="flex items-center justify-center gap-1.5 mb-8 animate-fade-in" style={{ animationDelay: "0.25s" }}>
          <MapPin className="h-3.5 w-3.5 md:h-4 md:w-4 text-white" aria-hidden="true" />
          <span className="text-[11px] md:text-sm font-body tracking-wider md:tracking-widest uppercase text-white">
            Panama City Beach, Florida
          </span>
        </div>
        <div className="animate-fade-in-up" style={{ animationDelay: "0.3s" }}>
          <Button
            size="lg"
            className="bg-accent text-accent-foreground hover:bg-accent/90 font-body text-base px-8 py-6 rounded-full shadow-elevated"
            onClick={() => document.getElementById("properties")?.scrollIntoView({ behavior: "smooth" })}
          >
            Explore Properties
          </Button>
        </div>
        <InventoryStrip
          variant="hero"
          limit={3}
          className="mt-8 max-w-3xl mx-auto animate-fade-in-up"
        />
        <div
          className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/90 text-xs md:text-sm font-body animate-fade-in"
          style={{ animationDelay: "0.4s" }}
        >
          <span className="flex items-center gap-1.5">
            <Home className="h-3.5 w-3.5 md:h-4 md:w-4" aria-hidden="true" />
            Locally managed
          </span>
          <span className="hidden md:inline text-white/40">·</span>
          <span className="flex items-center gap-1.5">
            <MapPin className="h-3.5 w-3.5 md:h-4 md:w-4" aria-hidden="true" />
            Premium location
          </span>
          <span className="hidden md:inline text-white/40">·</span>
          <span className="flex items-center gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5 md:h-4 md:w-4" aria-hidden="true" />
            Direct-book savings
          </span>
        </div>
      </div>

    </section>
  );
};

export default HeroSection;
